import React, { createContext, useContext, useState, useEffect } from 'react';

const OrgContext = createContext();

export const useOrg = () => {
  const context = useContext(OrgContext);
  if (!context) {
    throw new Error('useOrg must be used within an OrgProvider');
  }
  return context;
};

export const OrgProvider = ({ children }) => {
  const [org, setOrgState] = useState(null);
  const [isHydrating, setIsHydrating] = useState(true);

  // Load org from localStorage on mount
  useEffect(() => {
    const storedOrg = localStorage.getItem('barebiologics_org');
    if (storedOrg && (storedOrg === 'bare' || storedOrg === 'epl')) {
      setOrgState(storedOrg);
    }
    setIsHydrating(false);
  }, []);

  const setOrg = (newOrg) => {
    setOrgState(newOrg);
    if (newOrg) {
      localStorage.setItem('barebiologics_org', newOrg);
    } else {
      localStorage.removeItem('barebiologics_org');
    }
  };

  const clearOrg = () => {
    setOrgState(null);
    localStorage.removeItem('barebiologics_org');
  };

  const value = {
    org,
    setOrg,
    clearOrg,
    isHydrating
  };

  return (
    <OrgContext.Provider value={value}>
      {children}
    </OrgContext.Provider>
  );
};

export default OrgContext;
